import { render } from "./UiSuccess.vue?vue&type=template&id=9d5ccece"
import script from "./UiSuccess.vue?vue&type=script&lang=js"
export * from "./UiSuccess.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__